<template>
  <div class="title">
    <h1>Hello, world</h1>
    <div class="profile-image">
        <img alt="Amy Soetopo" src="../assets/amy.jpg" id="amy">
      </div>
    <div class="align-left">
      <p>
        I am Amy Soetopo, a nomadic software developer.
      </p>
      <p>
        I can usually be found in Vancouver, Canada 🇨🇦, around Spain 🇪🇸 or various parts of Indonesia 🇮🇩.
      </p>
      <p>
        My fascination with tech is rooted in the potential we have to add real value through solving problems and making our lives more efficient (but not lazy).
      </p>
      <p>
        I have worked in Fintech, Healthtech and am currently working on broadcasting software for events.
      </p>
    </div>
    
    <div class="align-left">
      <h2>Find me online</h2>
      <p>
        <a href="https://github.com/astopo">Github</a>
      </p>
      <p>
        <a href="https://linkedin.com/in/astopo">LinkedIn</a>
      </p>
      <!--
      <p>
        <a href="http://til.astopo.com">til.astopo.com</a> - Less of a "blog", and more of a place to jot down notes for myself to occassionally go back to.
      </p>
    -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Online',
  props: {
    title: String
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.profile-image img {
  border-radius: 50%;
  max-width: 200px;
  display: inline;
}

@media (min-width: 48em) {
  .profile-image img {
    display: none;
  }
}
</style>
